export default __webpack_public_path__ + "static/realWorldImg4-ccc73b1c4aa092283febbc8d4d6feec8.png";